import React, { useState } from "react";
import { Button } from "./ui/button";
import { TOUR_STEPS } from "../lib/onboardingConfig";
import { X, ArrowRight, ArrowLeft, Compass } from "lucide-react";

export function GuidedTour({ open, onClose }) {
  const [i, setI] = useState(0);
  if (!open) return null;
  const step = TOUR_STEPS[i];
  const last = i === TOUR_STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="guided-tour">
      <div className="card-flat bg-card w-full max-w-md p-6 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground" data-testid="tour-close">
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-center gap-2 mb-4">
          <div className="h-8 w-8 bg-accent flex items-center justify-center rounded-sm">
            <Compass className="h-4 w-4 text-black" />
          </div>
          <div className="label-eyebrow">Guided tour · {i + 1} / {TOUR_STEPS.length}</div>
        </div>
        <h3 className="font-display text-2xl font-bold tracking-tight">{step.title}</h3>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{step.body}</p>

        <div className="flex items-center gap-1.5 mt-5">
          {TOUR_STEPS.map((_, idx) => (
            <div key={idx} className={`h-1.5 rounded-full transition-all ${idx === i ? "w-6 bg-accent" : "w-1.5 bg-border"}`} />
          ))}
        </div>

        <div className="flex items-center justify-between mt-6">
          <Button variant="ghost" size="sm" onClick={onClose} data-testid="tour-skip">Skip tour</Button>
          <div className="flex gap-2">
            {i > 0 && <Button variant="outline" size="sm" onClick={() => setI(i - 1)} data-testid="tour-prev"><ArrowLeft className="h-4 w-4" /> Back</Button>}
            <Button variant="primary" size="sm" onClick={() => (last ? onClose() : setI(i + 1))} data-testid="tour-next">
              {last ? "Get started" : <>Next <ArrowRight className="h-4 w-4" /></>}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
